// @ts-strict

import { Component, Input } from '@angular/core';
import { ISingleCampaign, SpecialCampaignData } from '@app/core/models/core-models';
import { defaultImage } from '@app/core/helpers/constants';

@Component({
  selector: 'app-information-image',
  templateUrl: './information-image.component.html',
  styleUrls: ['./information-image.component.scss']
})
export class InformationImageComponent {
  @Input() currentCampaign?: SpecialCampaignData | ISingleCampaign;

  public mobilePreview = false;
  public readonly defaultImage = defaultImage;

  public activeBtnHandler(): void {
    this.mobilePreview = !this.mobilePreview;
  }
}
